module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/link-task-ca8400f22fee95341ff2b934f8ef0bc7.svg";